import React from 'react';
import Section from '../Section';
import TitledContent from '../TitledContent';
import masks from '../../utils';

const ConfirmAddressData = ({
  clientCEP,
  clientAddress,
  clientNumber,
  clientAddition,
  clientNeighborhood,
  clientCity,
  clientState,
}) => (
  <Section displayGrid title="Endereço">
    <TitledContent fullWidth title="CEP" content={masks.cep.mask(clientCEP)} />
    <TitledContent fullWidth title="Endereço" content={clientAddress} />
    <TitledContent title="Número" content={clientNumber} />

    <TitledContent title="Complemento" content={clientAddition} />

    <TitledContent title="Bairro" content={clientNeighborhood} />
    <TitledContent title="Cidade" content={clientCity} />

    <TitledContent title="UF" content={clientState} />
  </Section>
);

export default ConfirmAddressData;
